import Vue from 'vue';
import i18n from "./i18n";
import store from "@/store";


function shopName() {
  return store.state.settings && store.state.settings.shop_custom_name
    ? store.state.settings.shop_custom_name
    : i18n.t("Shop.default_shop_name");
}
function setShopName(str) {
  return i18n.t(str, [shopName()])
}
Vue.filter('setShopName', setShopName);

function allianceName() {
  return store.state.settings && store.state.settings.agent_custom_name
    ? store.state.settings.agent_custom_name
    : i18n.t("Alliances.default_alliance_name");
}

var subAccountStatus = [
  {
    text: i18n.t("SubAccountDetail.status.invalid"),
    color: "gray",
    textColor: "white",
    value: -2,
  },
  {
    text: i18n.t("SubAccountDetail.status.new"),
    color: "gray",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("SubAccountDetail.status.queued"),
    color: "secondary",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("SubAccountDetail.status.started"),
    color: "info",
    textColor: "white",
    value: 3,
  },
  {
    text: i18n.t("SubAccountDetail.status.success"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
];
// 查找Status
function subAccountStatusItem(value) {
  var item = subAccountStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function subAccountStatusText(value) {
  return subAccountStatusItem(value).text;
}
Vue.filter('subAccountStatusText', subAccountStatusText);
function subAccountStatusColor(value) {
  return subAccountStatusItem(value).color;
}
Vue.filter('subAccountStatusColor', subAccountStatusColor);
function subAccountStatusTextColor(value) {
  return subAccountStatusItem(value).textColor;
}
Vue.filter('subAccountStatusTextColor', subAccountStatusTextColor);

var orderStatus = [
  {
    text: i18n.t("Order.status.new"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("Order.status.confirmed"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("Order.status.granted"),
    color: "primary",
    textColor: "white",
    value: 3,
  },
  {
    text: i18n.t("Order.status.out_stock"),
    color: "primary",
    textColor: "white",
    value: 4,
  },
  {
    text: i18n.t("Order.status.distributed"),
    color: "primary",
    textColor: "white",
    value: 5,
  },
  {
    text: i18n.t("Order.status.finished"),
    color: "primary",
    textColor: "white",
    value: 6,
  },
];
// 查找Status
function orderStatusItem(value) {
  var item = orderStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function orderStatusText(value) {
  return orderStatusItem(value).text;
}
Vue.filter('orderStatusText', orderStatusText);
function orderStatusColor(value) {
  return orderStatusItem(value).color;
}
Vue.filter('orderStatusColor', orderStatusColor);
function orderStatusTextColor(value) {
  return orderStatusItem(value).textColor;
}
Vue.filter('orderStatusTextColor', orderStatusTextColor);

// 分账状态查询
var searchSubAccountStatus = [
  {
    text: i18n.t("SubAccountDetail.status.new"),
    color: "grey",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("SubAccountDetail.status.queued"),
    color: "info",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("SubAccountDetail.status.success"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
];
// 查找Status
function searchSubAccountStatusItem(value) {
  var item = searchSubAccountStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function searchSubAccountStatusText(value) {
  return searchSubAccountStatusItem(value).text;
}
Vue.filter('searchSubAccountStatusText', searchSubAccountStatusText);
function searchSubAccountStatusColor(value) {
  return searchSubAccountStatusItem(value).color;
}
Vue.filter('searchSubAccountStatusColor', searchSubAccountStatusColor);
function searchSubAccountStatusTextColor(value) {
  return searchSubAccountStatusItem(value).textColor;
}
Vue.filter('searchSubAccountStatusTextColor', searchSubAccountStatusTextColor);

// 商品预售状态状态
var presaleFlgs = [
  {
    text: i18n.t("SubAccountAnalyses.presaleFlgs.on"),
    color: "primary",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("SubAccountAnalyses.presaleFlgs.off"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
];
// 查找Status
function presaleFlgsItem(value) {
  var item = presaleFlgs.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function presaleFlgsText(value) {
  return presaleFlgsItem(value).text;
}
Vue.filter('presaleFlgsText', presaleFlgsText);
function presaleFlgsColor(value) {
  return presaleFlgsItem(value).color;
}
Vue.filter('presaleFlgsColor', presaleFlgsColor);
function presaleFlgsTextColor(value) {
  return presaleFlgsItem(value).textColor;
}
Vue.filter('presaleFlgsTextColor', presaleFlgsTextColor);

var orderOriginFlgs = [
  {
    text: i18n.t("Order.originFlgs.account"),
    value: "001",
  },
  {
    text: i18n.t("Order.originFlgs.shop"),
    value: "002",
  },
  {
    text: i18n.t("Order.originFlgs.shop_android"),
    value: "101",
  },
  {
    text: i18n.t("Order.originFlgs.shop_ios"),
    value: "102",
  },
  {
    text: i18n.t("Order.originFlgs.wechat_applet"),
    value: "103",
  },
  {
    text: i18n.t("Order.originFlgs.agent_android"),
    value: "201",
  },
  {
    text: i18n.t("Order.originFlgs.api2_shop"),
    value: "301",
  },
  {
    text: i18n.t("Order.originFlgs.api2_buyer"),
    value: "302",
  },
  {
    text: i18n.t("Order.originFlgs.weimob"),
    value: "401",
  },
  {
    text: i18n.t("Order.originFlgs.excel_buyer_import"),
    value: "402",
  },
  {
    text: i18n.t("Order.originFlgs.excel_import"),
    value: "003",
  },
  {
    text: i18n.t("Order.originFlgs.purchase"),
    value: "501",
  },
  {
    text: i18n.t("Order.originFlgs.default"),
    value: "000",
  },
];
// 查找OriginFlgs
function orderOriginFlgsItem(value) {
  var item = orderOriginFlgs.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Order.originFlgs.default"),
    value: "000",
  };
}
function orderOriginFlgsText(value) {
  return orderOriginFlgsItem(value).text;
}
Vue.filter('orderOriginFlgsText', orderOriginFlgsText);

var billStatus = [
  {
    text: i18n.t("Bill.status.new"),
    color: "gray",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("Bill.status.finished"),
    color: "primary",
    textColor: "white",
    value: 3,
  },
];
// 查找Status
function billStatusItem(value) {
  var item = billStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function billStatusText(value) {
  return billStatusItem(value).text;
}
Vue.filter('billStatusText', billStatusText);
function billStatusColor(value) {
  return billStatusItem(value).color;
}
Vue.filter('billStatusColor', billStatusColor);
function billStatusTextColor(value) {
  return billStatusItem(value).textColor;
}
Vue.filter('billStatusTextColor', billStatusTextColor);
// 商品销售类型 销售统计页面
var autoFlg = [
  {
    text: i18n.t("auto_flg.sale"),
    color: "primary",
    textColor: "white",
    value: 0
  },
  {
    text: i18n.t("auto_flg.bundle_sale"),
    color: "primary",
    textColor: "white",
    value: 1
  },
  {
    text: i18n.t("auto_flg.on_sale"),
    color: "primary",
    textColor: "white",
    value: 2
  },
  {
    text: i18n.t("auto_flg.combine_material"),
    color: "primary",
    textColor: "white",
    value: 3
  },
];
// 查找商品销售类型 
function autoFlgItem(value){
  var item = autoFlg.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  }
}
function autoFlgText(value){
  return autoFlgItem(value).text;
}
Vue.filter('autoFlgText', autoFlgText)
function autoFlgColor(value){
  return autoFlgItem(value).color;
}
Vue.filter('autoFlgColor', autoFlgColor)
function autoFlgTextColor(value){
  return autoFlgItem(value).textColor;
}
Vue.filter('autoFlgTextColor', autoFlgTextColor)

// 配送状态
var distributionStatus = [
  {
    text: i18n.t("MaterialDistribution.Status.expect"),
    color:"primary",
    textColor:"white",
    value: 1
  },
  {
    text: i18n.t("MaterialDistribution.Status.being"),
    color:"primary",
    textColor:"white",
    value: 2
  },
  {
    text: i18n.t("MaterialDistribution.Status.complete"),
    color:"primary",
    textColor:"white",
    value: 3
  }
]
// 查找配送状态
function distributionStatusItem(value){
  var item = distributionStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  }
}
function distributionStatusText(value){
  return distributionStatusItem(value).text;
}
Vue.filter('distributionStatusText', distributionStatusText)
function distributionStatusColor(value){
  return distributionStatusItem(value).color
}
Vue.filter('distributionStatusColor',distributionStatusColor)
function distributionStatusTextColor(value){
  return distributionStatusItem(value).textColor
}
Vue.filter('distributionStatusTextColor',distributionStatusTextColor)

// 订单毛利分析状态
var orderProfitStatus = [
  {
    text: i18n.t("orderProfitAnalyze.status.distribution"),
    color:"primary",
    textColor:"white",
    value: 4
  },
  {
    text: i18n.t("orderProfitAnalyze.status.check"),
    color:"primary",
    textColor:"white",
    value: 5
  },
  {
    text: i18n.t("orderProfitAnalyze.status.complete"),
    color:"primary",
    textColor:"white",
    value: 6
  }
]
// 查找配送状态
function orderProfitStatusItem(value){
  var item = orderProfitStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  }
}
function orderProfitStatusText(value){
  return orderProfitStatusItem(value).text;
}
Vue.filter('orderProfitStatusText', orderProfitStatusText)
function orderProfitStatusColor(value){
  return orderProfitStatusItem(value).color
}
Vue.filter('orderProfitStatusColor',orderProfitStatusColor)
function orderProfitStatusTextColor(value){
  return orderProfitStatusItem(value).textColor
}
Vue.filter('orderProfitStatusTextColor',orderProfitStatusTextColor)


// 门店分析
var shopProfitStatus = [
  {
    text: i18n.t("orderProfitAnalyze.status.distribution"),
    color:"primary",
    textColor:"white",
    value: 4
  },
  {
    text: i18n.t("orderProfitAnalyze.status.check"),
    color:"primary",
    textColor:"white",
    value: 5
  },
  {
    text: i18n.t("orderProfitAnalyze.status.complete"),
    color:"primary",
    textColor:"white",
    value: 6
  }
]
// 查找配送状态  
function shopProfitStatusItem(value){
  var item = shopProfitStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  }
}
function shopProfitStatusText(value){
  return shopProfitStatusItem(value).text;
}
Vue.filter('shopProfitStatusText', shopProfitStatusText)
function shopProfitStatusColor(value){
  return shopProfitStatusItem(value).color
}
Vue.filter('shopProfitStatusColor',shopProfitStatusColor)
function shopProfitStatusTextColor(value){
  return shopProfitStatusItem(value).textColor
}
Vue.filter('shopProfitStatusTextColor',shopProfitStatusTextColor)

var billPayFlgs = [
  {
    text: i18n.t("Bill.payFlgs.unpay"),
    color: "accent",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("Bill.payFlgs.pay_apart"),
    color: "accent",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("Bill.payFlgs.paid"),
    color: "primary",
    textColor: "white",
    value: 3,
  },
];
// 查找PayFlgs
function billPayFlgsItem(value) {
  var item = billPayFlgs.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function billPayFlgsText(value) {
  return billPayFlgsItem(value).text;
}
Vue.filter('billPayFlgsText', billPayFlgsText);
function billPayFlgsColor(value) {
  return billPayFlgsItem(value).color;
}
Vue.filter('billPayFlgsColor', billPayFlgsColor);
function billPayFlgsTextColor(value) {
  return billPayFlgsItem(value).textColor;
}
Vue.filter('billPayFlgsTextColor', billPayFlgsTextColor);

var billRealPayFlgs = [
  {
    text: i18n.t("Bill.payFlgs.pay_apart"),
    color: "accent",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("Bill.payFlgs.paid"),
    color: "primary",
    textColor: "white",
    value: 3,
  },
];
// 查找PayFlgs
function billRealPayFlgsItem(value) {
  var item = billRealPayFlgs.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function billRealPayFlgsText(value) {
  return billRealPayFlgsItem(value).text;
}
Vue.filter('billRealPayFlgsText', billRealPayFlgsText);
function billRealPayFlgsColor(value) {
  return billRealPayFlgsItem(value).color;
}
Vue.filter('billRealPayFlgsColor', billRealPayFlgsColor);
function billRealPayFlgsTextColor(value) {
  return billRealPayFlgsItem(value).textColor;
}
Vue.filter('billRealPayFlgsTextColor', billRealPayFlgsTextColor);

//门店分账汇总支付方式
var shopSubAccountPayTypes = [
  {
    text: i18n.t("ShopSubAccountSum.payTypes.ABC"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("ShopSubAccountSum.payTypes.cash"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("ShopSubAccountSum.payTypes.other"),
    color: "primary",
    textColor: "white",
    value: 3,
  },
];
// 查找PayFlgs
function shopSubAccountPayTypesItem(value) {
  var item = shopSubAccountPayTypes.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function shopSubAccountPayTypesText(value) {
  return shopSubAccountPayTypesItem(value).text;
}
Vue.filter('shopSubAccountPayTypesText', shopSubAccountPayTypesText);
function shopSubAccountPayTypesColor(value) {
  return shopSubAccountPayTypesItem(value).color;
}
Vue.filter('shopSubAccountPayTypesColor', shopSubAccountPayTypesColor);
function shopSubAccountPayTypesTextColor(value) {
  return shopSubAccountPayTypesItem(value).textColor;
}
Vue.filter('shopSubAccountPayTypesTextColor', shopSubAccountPayTypesTextColor);

var examineStatus = [
  {
    text: i18n.t("MaterialExamine.status.distributed"),
    color: "accent",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("MaterialExamine.status.finished"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
];
// 查找Examine Status
function examineStatusItem(value) {
  var item = examineStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function examineStatusText(value) {
  return examineStatusItem(value).text;
}
Vue.filter('examineStatusText', examineStatusText);
function examineStatusColor(value) {
  return examineStatusItem(value).color;
}
Vue.filter('examineStatusColor', examineStatusColor);
function examineStatusTextColor(value) {
  return examineStatusItem(value).textColor;
}
Vue.filter('examineStatusTextColor', examineStatusTextColor);

// 查找Examine Flgs
var examineFlgs = [
  {
    text: i18n.t("MaterialExamine.examineFlgs.examine_flg_wait"),
    color: "accent",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("MaterialExamine.examineFlgs.examine_flg_shop"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("MaterialExamine.examineFlgs.examine_flg_account"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("MaterialExamine.examineFlgs.examine_flg_system"),
    color: "primary",
    textColor: "white",
    value: 3,
  },
  {
    text: i18n.t("MaterialExamine.examineFlgs.examine_flg_agent"),
    color: "primary",
    textColor: "white",
    value: 4,
  },
];
function examineFlgsItem(value) {
  var item = examineFlgs.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function examineFlgsText(value) {
  return examineFlgsItem(value).text;
}
Vue.filter('examineFlgsText', examineFlgsText);
function examineFlgsColor(value) {
  return examineFlgsItem(value).color;
}
Vue.filter('examineFlgsColor', examineFlgsColor);
function examineFlgsTextColor(value) {
  return examineFlgsItem(value).textColor;
}
Vue.filter('examineFlgsTextColor', examineFlgsTextColor);

// 查找Examine AbnormalFlgs
var examineAbnormalFlgs = [
  {
    text: i18n.t("MaterialExamine.abnormalFlgs.normal"),
    color: "primary",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("MaterialExamine.abnormalFlgs.abnormal"),
    color: "accent",
    textColor: "white",
    value: 1,
  },
];
function examineAbnormalFlgsItem(value) {
  var item = examineAbnormalFlgs.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function examineAbnormalFlgsText(value) {
  return examineAbnormalFlgsItem(value).text;
}
Vue.filter('examineAbnormalFlgsText', examineAbnormalFlgsText);
function examineAbnormalFlgsColor(value) {
  return examineAbnormalFlgsItem(value).color;
}
Vue.filter('examineAbnormalFlgsColor', examineAbnormalFlgsColor);
function examineAbnormalFlgsTextColor(value) {
  return examineAbnormalFlgsItem(value).textColor;
}
Vue.filter('examineAbnormalFlgsTextColor', examineAbnormalFlgsTextColor);

// 查找Examine AbnormalFlgs,异常处理状态
var examineIsAbnormaled = [
  {
    text: i18n.t("MaterialExamine.abnormalFlgs.normal"),
    color: "primary",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("MaterialExamine.abnormalFlgs.abnormal_untreaded"),
    color: "accent",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("MaterialExamine.abnormalFlgs.abnormal_handeld"),
    color: "accent",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("MaterialExamine.abnormalFlgs.abnormal_complete"),
    color: "accent",
    textColor: "white",
    value: 3,
  },
];
function examineIsAbnormaledItem(value) {
  var item = examineIsAbnormaled.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function examineIsAbnormaledText(value) {
  return examineIsAbnormaledItem(value).text;
}
Vue.filter('examineIsAbnormaledText', examineIsAbnormaledText);
function examineIsAbnormaledColor(value) {
  return examineIsAbnormaledItem(value).color;
}
Vue.filter('examineIsAbnormaledColor', examineIsAbnormaledColor);
function examineIsAbnormaledTextColor(value) {
  return examineIsAbnormaledItem(value).textColor;
}
Vue.filter('examineIsAbnormaledTextColor', examineIsAbnormaledTextColor);

// 门店分析
var materialProfitStatus = [
  {
    text: i18n.t("materialProfitAnalyze.status.distribution"),
    color:"primary",
    textColor:"white",
    value: 4
  },
  {
    text: i18n.t("materialProfitAnalyze.status.check"),
    color:"primary",
    textColor:"white",
    value: 5
  },
  {
    text: i18n.t("materialProfitAnalyze.status.complete"),
    color:"primary",
    textColor:"white",
    value: 6
  }
]
// 查找配送状态  
function materialProfitStatusItem(value){
  var item = materialProfitStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  }
}
function materialProfitStatusText(value){
  return materialProfitStatusItem(value).text;
}
Vue.filter('materialProfitStatusText', materialProfitStatusText)
function materialProfitStatusColor(value){
  return materialProfitStatusItem(value).color
}
Vue.filter('materialProfitStatusColor',materialProfitStatusColor)
function materialProfitStatusTextColor(value){
  return materialProfitStatusItem(value).textColor
}
Vue.filter('materialProfitStatusTextColor',materialProfitStatusTextColor)

// 未订货统计
var orderBacklogStatus = [
  {
    text: i18n.t("OrderBacklog.status.arrears"),
    color:"primary",
    textColor:"white",
    value: 3
  },
  {
    text: i18n.t("OrderBacklog.status.off"),
    color:"primary",
    textColor:"white",
    value: 0
  },
  {
    text: i18n.t("OrderBacklog.status.on"),
    color:"primary",
    textColor:"white",
    value: 1
  },
  {
    text: i18n.t("OrderBacklog.status.stop"),
    color:"primary",
    textColor:"white",
    value: 2
  },
  
]
// 查找客户状态 
function orderBacklogStatusItem(value){
  var item = orderBacklogStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  }
}
function orderBacklogStatusText(value){
  return orderBacklogStatusItem(value).text;
}
Vue.filter('orderBacklogStatusText', orderBacklogStatusText)
function orderBacklogStatusColor(value){
  return orderBacklogStatusItem(value).color
}
Vue.filter('orderBacklogStatusColor',orderBacklogStatusColor)
function orderBacklogStatusTextColor(value){
  return orderBacklogStatusItem(value).textColor
}
Vue.filter('orderBacklogStatusTextColor',orderBacklogStatusTextColor)

var cancelFlgs = [
  {
    text: i18n.t("CancelFlgs.off"),
    color: "primary",
    textColor: "white",
    value: 0
  },
  {
    text: i18n.t("CancelFlgs.on"),
    color: "grey",
    textColor: "white",
    value: 1
  }
];
// 查找cancelFlgs
function cancelFlgsItem(value) {
  value = value ? 1 : 0;// 有值都当on
  return cancelFlgs.find((element) => element.value == value);
}
function cancelFlgsText(value) {
  return cancelFlgsItem(value).text;
}
Vue.filter('cancelFlgsText', cancelFlgsText);
function cancelFlgsColor(value) {
  return cancelFlgsItem(value).color;
}
Vue.filter('cancelFlgsColor', cancelFlgsColor);
function cancelFlgsTextColor(value) {
  return cancelFlgsItem(value).textColor;
}
Vue.filter('cancelFlgsTextColor', cancelFlgsTextColor);

//月度要货状态
var monthlyStatisticssOrderStatus = [
  {
    text: i18n.t("MonthlyStatisticss.status.wait_confirm"),
    color: "primary",
    textColor: "white",
    value: 1
  },
  {
    text: i18n.t("MonthlyStatisticss.status.wait_approve"),
    color: "primary",
    textColor: "white",
    value: 2
  },
  {
    text: i18n.t("MonthlyStatisticss.status.wait_stock_out"),
    color: "primary",
    textColor: "white",
    value: 3
  },
  {
    text: i18n.t("MonthlyStatisticss.status.wait_distribution"),
    color: "primary",
    textColor: "white",
    value: 4
  },
  {
    text: i18n.t("MonthlyStatisticss.status.wait_exmine"),
    color: "primary",
    textColor: "white",
    value: 5
  },
  {
    text: i18n.t("MonthlyStatisticss.status.finished"),
    color: "primary",
    textColor: "white",
    value: 6
  }
];
// 查找monthlyStatisticssOrderStatus
function monthlyStatisticssOrderStatusItem(value) {
  value = value ? 1 : 0;// 有值都当on
  return monthlyStatisticssOrderStatus.find((element) => element.value == value);
}
function monthlyStatisticssOrderStatusText(value) {
  return monthlyStatisticssOrderStatusItem(value).text;
}
Vue.filter('monthlyStatisticssOrderStatusText', monthlyStatisticssOrderStatusText);
function monthlyStatisticssOrderStatusColor(value) {
  return monthlyStatisticssOrderStatusItem(value).color;
}
Vue.filter('monthlyStatisticssOrderStatusColor', monthlyStatisticssOrderStatusColor);
function monthlyStatisticssOrderStatusTextColor(value) {
  return monthlyStatisticssOrderStatusItem(value).textColor;
}
Vue.filter('monthlyStatisticssOrderStatusTextColor', monthlyStatisticssOrderStatusTextColor);

// 月度退货状态
var monthlyStatisticssReturnOrderStatus = [
  {
    text: i18n.t("MonthlyStatisticss.status.wait_confirm"),
    color: "primary",
    textColor: "white",
    value: 1
  },
  {
    text: i18n.t("MonthlyStatisticss.status.wait_approve"),
    color: "primary",
    textColor: "white",
    value: 2
  },
  {
    text: i18n.t("MonthlyStatisticss.status.wait_stock_in"),
    color: "primary",
    textColor: "white",
    value: 3
  },
  {
    text: i18n.t("MonthlyStatisticss.status.finished"),
    color: "primary",
    textColor: "white",
    value: 4
  },
];
// monthlyStatisticssReturnOrderStatus
function monthlyStatisticssReturnOrderStatusItem(value) {
  value = value ? 1 : 0;// 有值都当on
  return monthlyStatisticssReturnOrderStatus.find((element) => element.value == value);
}
function monthlyStatisticssReturnOrderStatusText(value) {
  return monthlyStatisticssReturnOrderStatusItem(value).text;
}
Vue.filter('monthlyStatisticssReturnOrderStatusText', monthlyStatisticssReturnOrderStatusText);
function monthlyStatisticssReturnOrderStatusColor(value) {
  return monthlyStatisticssReturnOrderStatusItem(value).color;
}
Vue.filter('monthlyStatisticssReturnOrderStatusColor', monthlyStatisticssReturnOrderStatusColor);
function monthlyStatisticssReturnOrderStatusTextColor(value) {
  return monthlyStatisticssReturnOrderStatusItem(value).textColor;
}
Vue.filter('monthlyStatisticssReturnOrderStatusTextColor', monthlyStatisticssReturnOrderStatusTextColor);

function getDayStart() {
  var from = new Date();
  from.setHours(0, 0, 0, 0);
  return from;
}
function getDayEnd() {
  var end = new Date();
  end.setHours(23, 59, 59, 999);
  return end;
}
export default {
  shopName,
  allianceName,
  limitAll: 10000000,
  autoFlg,
  cancelFlgs,
  orderProfitStatus,
  shopProfitStatus,
  materialProfitStatus,
  order: {
    status: orderStatus,
    origin_flgs: orderOriginFlgs,
  },
  orderBacklogStatus,
  bill: {
    status: billStatus,
    pay_flgs: billPayFlgs,
    real_pay_flgs: billRealPayFlgs,
  },
  subAccountAnalyses: {
    status: orderStatus.slice(2),
    pay_flgs: billPayFlgs.slice(1),
    presale_flgs: presaleFlgs,
    sub_account_status:searchSubAccountStatus
  },
  shopSubAccount: {
    pay_types: shopSubAccountPayTypes,
  },
  examine: {
    status: examineStatus,
    abnormal_flgs: examineAbnormalFlgs,
    is_abnormal: examineIsAbnormaled,
    examine_flgs: examineFlgs,
  },
  distribution:{
    distribution_status: distributionStatus
  },
  monthlyStatisticss: {
    order_status: monthlyStatisticssOrderStatus,
    return_order_status: monthlyStatisticssReturnOrderStatus,
  },
  dateTimeRangeShortcuts: [
    {
      text: i18n.t("$datetime.shortcuts.today"),
      onClick: () => {
        return [getDayStart(), getDayEnd()];
      },
    },
    {
      text: i18n.t("$datetime.shortcuts.yesterday"),
      onClick: () => {
        const from = getDayStart();
        const end = getDayEnd();
        from.setDate(from.getDate() - 1);
        end.setDate(end.getDate() - 1);
        return [from, end];
      },
    },
    {
      text: i18n.t("$datetime.shortcuts.inOneWeek"),
      onClick: () => {
        const from = getDayStart();
        const end = getDayEnd();
        from.setDate(from.getDate() - 6);
        return [from, end];
      },
    },
    {
      text: i18n.t("$datetime.shortcuts.inOneMonth"),
      onClick: () => {
        const from = getDayStart();
        const end = getDayEnd();
        from.setMonth(from.getMonth() - 1);
        from.setDate(from.getDate() + 1);
        return [from, end];
      },
    },
    // {
    //   text: i18n.t("$datetime.shortcuts.inHalfYear"),
    //   onClick: () => {
    //     const from = getDayStart();
    //     const end = getDayEnd();
    //     from.setMonth(from.getMonth() - 6);
    //     from.setDate(from.getDate() + 1);
    //     return [from, end];
    //   },
    // },
    // {
    //   text: i18n.t("$datetime.shortcuts.inOneYear"),
    //   onClick: () => {
    //     const from = getDayStart();
    //     const end = getDayEnd();
    //     from.setFullYear(from.getFullYear() - 1);
    //     from.setDate(from.getDate() + 1);
    //     return [from, end];
    //   },
    // },
    {
      text: i18n.t("$datetime.shortcuts.thisWeek"),
      onClick: () => {
        const from = getDayStart();
        const end = getDayEnd();
        var day = from.getDay()
        if (day == 0) {
           day = 7
         }
        from.setDate(from.getDate() - day + 1);
        end.setDate(end.getDate() + 7 - day);
        return [from, end];
      },
    },
    {
      text: i18n.t("$datetime.shortcuts.lastWeek"),
      onClick: () => {
        const from = getDayStart();
        const end = getDayEnd();
        var day = from.getDay()
        if (day == 0) {
          day = 7
        }
        from.setDate(from.getDate() - 6 - day);
        end.setDate(end.getDate() - day);
        return [from, end];
      },
    },
    {
      text: i18n.t("$datetime.shortcuts.thisMonth"),
      onClick: () => {
        const from = getDayStart();
        const end = getDayEnd();
        from.setDate(1);
        end.setMonth(end.getMonth() + 1);
        end.setDate(0);
        return [from, end];
      },
    },
    {
      text: i18n.t("$datetime.shortcuts.lastMonth"),
      onClick: () => {
        const from = getDayStart();
        const end = getDayEnd();
        from.setDate(1);
        from.setMonth(from.getMonth() - 1);
        end.setDate(0);
        return [from, end];
      },
    },
    {
      text: i18n.t("$datetime.shortcuts.thisYear"),
      onClick: () => {
        const from = getDayStart();
        const end = getDayEnd();
        from.setMonth(0);
        from.setDate(1);
        end.setFullYear(end.getFullYear() + 1);
        end.setMonth(0);
        end.setDate(0);
        return [from, end];
      },
    },
    {
      text: i18n.t("$datetime.shortcuts.lastYear"),
      onClick: () => {
        const from = getDayStart();
        const end = getDayEnd();
        from.setMonth(0);
        from.setDate(1);
        from.setFullYear(from.getFullYear() - 1);
        end.setMonth(0);
        end.setDate(0);
        return [from, end];
      },
    },
  ],
}